import React, { Component, Fragment } from 'react';
import propTypes from 'prop-types';

import { EMPTY_COMPONENT_PAYLOAD } from 'app/PreviewPane/const';
import { noop } from 'lib/noop';

import Card from './Card';

/**
 * Component to re-order items through drag and drop feature in canvas editor pane.
 * @param {Array} children - list of components/items.
 * @param {object} changeItemsOrder - action to be dispatched when order of items changed.
 * @returns {React.Component} the DragAndDropList component.
 */
export default class DragAndDropList extends Component {
  static propTypes = {
    body: propTypes.node,
    cardClassName: propTypes.string,
    changeItemsOrder: propTypes.func.isRequired,
    children: propTypes.node,
    componentHoverEnter: propTypes.func,
    componentHoverLeave: propTypes.func,
    componentSelected: propTypes.object,
    componentHovering: propTypes.object,
    contentLinkDisabled: propTypes.bool,
    handleComponentSelection: propTypes.func,
    previewMetadata: propTypes.object
  };

  static defaultProps = {
    body: [],
    cardClassName: '',
    children: [],
    componentHoverEnter: noop,
    componentHovering: EMPTY_COMPONENT_PAYLOAD,
    componentHoverLeave: noop,
    componentSelected: EMPTY_COMPONENT_PAYLOAD,
    contentLinkDisabled: true,
    handleComponentSelection: noop,
    previewMetadata: {}
  };

  constructor(props) {
    super(props);
    this.moveCard = this.moveCard.bind(this);
    this.isSelected = this.isSelected.bind(this);
    this.isHovering = this.isHovering.bind(this);
  }

  /**
   * Repositions the items in the list
   * @param {number} dragIndex - index number of the dragged item
   * @param {number} hoverIndex - index numer where the item dragged to.
   */
  moveCard(dragIndex, hoverIndex) {
    const { changeItemsOrder } = this.props;
    changeItemsOrder(dragIndex, hoverIndex);
  }

  /**
   * Determine if the card should have a 'selected' component border
   * @param {object} component - current component/card
   * @returns {boolean} boolean
   */
  isSelected(component) {
    const { componentSelected } = this.props;
    if (
      component.key === componentSelected.Id ||
      componentSelected.variantIds?.includes(component.key) ||
      componentSelected.childComponentIds?.includes(component.key) ||
      component.props?.variantids?.includes(componentSelected.Id) ||
      component.props?.childids?.includes(componentSelected.Id)
    ) {
      return true;
    }
    return false;
  }

  /**
   * Determine if the card should have a 'hovering' component border
   * @param {object} component - current component/card
   * @returns {boolean} boolean
   */
  isHovering(component) {
    const { componentHovering } = this.props;
    if (
      component.key === componentHovering.Id ||
      componentHovering.variantIds?.includes(component.key) ||
      componentHovering.childComponentIds?.includes(component.key) ||
      component.props?.variantids?.includes(componentHovering.Id) ||
      component.props?.childids?.includes(componentHovering.Id)
    ) {
      return true;
    }
    return false;
  }

  render() {
    const {
      cardClassName,
      children,
      body,
      componentHoverEnter,
      componentHoverLeave,
      contentLinkDisabled,
      handleComponentSelection,
      previewMetadata
    } = this.props;

    return (
      <div className="w-100">
        {children.map((component, index) => {
          return (
            <Fragment key={index}>
              <Card
                className={cardClassName}
                index={index}
                onMoveCard={this.moveCard}
                previewMetadata={previewMetadata}
                selected={this.isSelected(component)}
                hovering={this.isHovering(component)}
                handleComponentSelection={handleComponentSelection}
                componentHoverEnter={componentHoverEnter}
                componentHoverLeave={componentHoverLeave}
                contentLinkDisabled={contentLinkDisabled}
              >
                {component}
              </Card>
              {body[index]}
            </Fragment>
          );
        })}
      </div>
    );
  }
}
